import { fromBaseQty } from "@/modules/inventory/domain/lib/unit-conversion";
import { formatQtyDisplay } from "@/shared/lib/format-number";

export function receiveQtyHint(
  qtyBase: number,
  baseUnit: string | null | undefined,
  receiveUnit: string | null | undefined,
  receiveToBase: number | null | undefined,
): string | null {
  if (
    !baseUnit ||
    !receiveUnit ||
    receiveToBase == null ||
    !(receiveToBase > 0) ||
    receiveToBase === 1
  ) {
    return null;
  }
  return `${formatQtyDisplay(fromBaseQty(qtyBase, receiveToBase))} ${receiveUnit}`;
}

/** ตัวเลขหลักเป็นหน่วยรับเข้า วงเล็บเป็นหน่วยฐานเมื่ออัตราไม่ใช่ 1. */
export function receivePrimaryLabel(
  qtyBase: number,
  baseUnit: string | null | undefined,
  receiveUnit: string | null | undefined,
  receiveToBase: number | null | undefined,
): { text: string; hint: string | null } {
  const factor = receiveToBase ?? 0;
  const unit = receiveUnit || baseUnit || "";
  if (receiveUnit && factor > 0 && factor !== 1) {
    return {
      text: `${formatQtyDisplay(fromBaseQty(qtyBase, factor))} ${receiveUnit}`,
      hint: `${formatQtyDisplay(qtyBase)} ${baseUnit ?? ""}`.trim(),
    };
  }
  return {
    text: `${formatQtyDisplay(qtyBase)}${unit ? ` ${unit}` : ""}`,
    hint: null,
  };
}

export function baseQtyHint(
  qty: number,
  factor: number | null | undefined,
  baseUnit: string | null | undefined,
): string | null {
  if (!baseUnit || factor == null || !(factor > 0) || factor === 1) return null;
  return `${formatQtyDisplay(qty * factor)} ${baseUnit}`;
}
